import PatientsInFacility from './PatientsInFacility';

export default PatientsInFacility;
